// extracted by css-extract-rspack-plugin
export default {"root":"root-eeVxC1","actions":"actions-OuWqSI"};